"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const getNumberFromUnknown_1 = __importDefault(require("../shared/getNumberFromUnknown"));
const valueIsNullOrUndef_1 = __importDefault(require("../typeAssertions/valueIsNullOrUndef"));
const valueIsNotUndefined_1 = __importDefault(require("../typeAssertions/valueIsNotUndefined"));
const getFromDatabaseCache_1 = __importDefault(require("../FirebaseDatabaseCache/getFromDatabaseCache"));
const getFromDatabaseFunction = ({ database, dbFirebaseListeners, addDbCacheListener, getDatabaseCache, }) => ({ path, timeToRefresh, listener, isRealTime, projectId, sendUpdateToDbCache, filter, startAt, endAt, orderBy, limitToFirst: rawLimitToFirst, limitToLast: rawLimitToLast, isDevelopment, }) => {
    const dbName = isDevelopment ? 'dataDevelopment' : 'data';
    let dataReference = database.ref(`projects/${projectId}/${dbName}/${path}`);
    if (filter && orderBy) {
        dataReference = dataReference.orderByChild(orderBy.toString()).equalTo(filter);
    }
    if (orderBy && !filter) {
        dataReference = dataReference.orderByChild(orderBy.toString());
    }
    if (orderBy && startAt) {
        dataReference = dataReference.startAt(startAt);
    }
    if (orderBy && endAt) {
        dataReference = dataReference.endAt(endAt);
    }
    let limitToFirst;
    if (!(0, valueIsNullOrUndef_1.default)(rawLimitToFirst)) {
        try {
            limitToFirst = (0, getNumberFromUnknown_1.default)(rawLimitToFirst);
            dataReference = dataReference.limitToFirst(limitToFirst);
        }
        catch (_a) {
            // No action to limit to first
        }
    }
    let limitToLast;
    if (!(0, valueIsNullOrUndef_1.default)(rawLimitToLast)) {
        try {
            limitToLast = (0, getNumberFromUnknown_1.default)(rawLimitToLast);
            dataReference = dataReference.limitToLast(limitToLast);
        }
        catch (_b) {
            // No action to limit to last
        }
    }
    if ((0, valueIsNotUndefined_1.default)(timeToRefresh) && timeToRefresh > 0) {
        const queryRoute = {
            path,
            endAt,
            filter,
            limitToFirst,
            orderBy,
            startAt,
            limitToLast,
        };
        const cacheData = (0, getFromDatabaseCache_1.default)({
            currentTimeInMillis: Date.now(),
            getCacheData: getDatabaseCache,
            maxAgeInMillis: timeToRefresh * 1000,
            route: queryRoute,
        });
        if (isRealTime) {
            if ((0, valueIsNotUndefined_1.default)(cacheData)) {
                listener({ val: () => cacheData });
            }
            const listenerId = (0, uuid_1.v1)();
            const enhanceCacheListener = (snapshot) => listener(snapshot);
            enhanceCacheListener.id = listenerId;
            const enhanceFirebaseListener = (snapshot) => {
                if (snapshot) {
                    sendUpdateToDbCache({
                        route: queryRoute,
                        data: snapshot.val(),
                    });
                }
                if (snapshot) {
                    listener(snapshot);
                }
            };
            addDbCacheListener(queryRoute, enhanceFirebaseListener);
            dbFirebaseListeners.push({ path, listener: enhanceFirebaseListener, dataReference });
            dataReference.on('value', enhanceFirebaseListener);
        }
        else if ((0, valueIsNotUndefined_1.default)(cacheData)) {
            listener({ val: () => cacheData });
        }
        else {
            const enhanceListener = (snapshot) => {
                sendUpdateToDbCache({
                    route: queryRoute,
                    data: snapshot.val(),
                });
                listener(snapshot);
            };
            dataReference.once('value').then(enhanceListener);
        }
    }
    else {
        if (isRealTime) {
            dbFirebaseListeners.push({ path, listener, dataReference });
            dataReference.on('value', listener);
            return;
        }
        dataReference.once('value').then(listener);
    }
};
exports.default = getFromDatabaseFunction;
